// После деплоя старые JS-чанки удаляются, но у пользователей может быть
// закешированный index.html со ссылками на них. Оборачиваем lazy-импорты:
// при ошибке загрузки — одноразовый reload, чтобы получить свежий index.html.
// Используется и для маршрутов роутера, и для defineAsyncComponent.

const RELOAD_FLAG = 'chunk-reload'

// Формулировки Chrome, Safari и Firefox соответственно
const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|is not a valid JavaScript MIME type|Importing a module script failed|error loading dynamically imported module|Loading chunk|Unable to preload CSS/

export function lazyLoad(importFn) {
  return () => importFn().then((mod) => {
    // Чанк загрузился — следующий деплой снова имеет право на автоперезагрузку
    sessionStorage.removeItem(RELOAD_FLAG)
    return mod
  }).catch((err) => {
    if (CHUNK_ERROR_RE.test(err?.message || '') && !sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload()
      // Держим потребителя в вечном ожидании: resolve в undefined заставил бы
      // vue-router бросить «Couldn't resolve component» до перезагрузки
      return new Promise(() => {})
    }
    throw err
  })
}
